import { useEffect } from 'react';
import { gql } from '@apollo/client';
import { Contact } from '@lgg/isomorphic/types/__generated__/graphql';
import { CONTACT_BLOCKING_FIELDS } from 'src/components/providers/apollo-provider-provider';
import { UseRefreshProps } from 'src/hooks/gql/use-refresh.shared';
import { isRefreshDataEventType } from 'src/types/type-guards';

export const CONTACT_FIELDS_FRAGMENT = gql`
  fragment ContactFields on Contact {
    id
    createdAt
    firstName
    fullName
    fullAddress
    lastContactInteraction {
      id
      occurredAt
    }
    interest
    label
    lastName
    primaryEmail
    primaryPhone {
      national
      e164
      regionCode
    }
    secondaryPhone {
      national
      e164
      regionCode
    }
    updatedAt
    stage {
      id
      name
      slug
    }
    status {
      id
      name
    }
    tags {
      id
      name
      isActive
    }
    assignee {
      id
      fullName
    }
    address1
    address2
    city
    addressState
    addressCountry
    postalCode
    campaign {
      id
    }
    source {
      id
    }
    sex
    birthdate
  }
`;
export const GET_CONTACT = gql`
  ${CONTACT_FIELDS_FRAGMENT}
  query GetContact($id: Int!) {
    contact(id: $id) {
      ...ContactFields
    }
  }
`;

export const GET_CONTACT_BLOCKED = gql`
  ${CONTACT_BLOCKING_FIELDS}
  query GetContact($id: Int!) {
    contact(id: $id) {
      id
      ...ContactBlockingFieldsFragment
    }
  }
`;

export const useRefreshContact = ({ onRefresh }: UseRefreshProps) => {
  useEffect(() => {
    const handleRefresh = (e, body) => {
      if (isRefreshDataEventType<Contact>(body, 'lead')) {
        const { id, action, contact } = body.entity;

        onRefresh({
          id,
          action,
          entityFullName: contact?.displayName,
        });
      }
    };

    window.jQuery(window).on('refreshLead', handleRefresh);

    return () => window.jQuery(window).off('refreshLead', handleRefresh);
  }, [onRefresh]);
};
